angular.module('deskfy.arts').controller('UserController', UserController)

/* @ngInject */
function UserController ($scope, $state, $translate, UserArtsService, AssetPreviewService, TemplateService, CONSTANTS, Utils, ToastService) {
  $scope.sidebar = {
    selectedMenuId: null,
    selectedItemId: null,
    items: []
  }
  $scope.companyFeatures = {
    artsCustomization: {
      access: true
    }
  }
  $scope.templateOptions = {
    edit: false,
    move: false,
    share: false,
    archive: false,
    download: true,
    settings: false,
    duplicate: false
  }
  $scope.isPreviewEnabled = AssetPreviewService.isPreviewEnabled

  const api = {
    _initSidebar,
    _loadCompanyFeatures
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._loadCompanyFeatures()
    api._initSidebar()
  }

  $scope.handleMenuPress = function (menuId) {
    const menus = {
      2: 'arts.me'
    }
    const selected = menus[+menuId]
    $state.go(selected ?? 'user.arts', {}, { reload: true })
  }

  $scope.handleMenuOpenItem = function (item) {
    $state.go('user.collection', { id: item.id }, { reload: true })
  }

  $scope.getArtCollectionThumbnail = collection => {
    const isToShowThumbnail = collection.random_template.isCustomizable || collection.random_template.thumbnailContentType || collection.random_template.hasCover || collection.thumbnailS3Key
    if (isToShowThumbnail) {
      collection.defaultThumb = false
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_THUMBNAIL, [collection.id])
      const cached = Utils.fnAddQueryToUrl(url, { cache: collection.updatedAt })
      return cached
    } else {
      collection.defaultThumb = true
      return TemplateService.getDefaultThumbnail(collection.random_template.extension)
    }
  }

  function _initSidebar () {
    UserArtsService.getSideBarItems()
      .then(response => {
        $scope.sidebar.items = [...($scope.sidebar.items ?? []), ...(response ?? [])]
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('userArts.sidebar.error'))
      })
  }

  function _loadCompanyFeatures () {
    UserArtsService.getCompanyFeatures()
      .then(response => {
        if (!response) return
        $scope.companyFeatures = response
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('userArts.features.error'))
      })
  }
}

export { UserController }
